import { render, staticRenderFns } from "./BeltsHero.vue?vue&type=template&id=3e4f866a&scoped=true"
var script = {}
import style0 from "./BeltsHero.vue?vue&type=style&index=0&id=3e4f866a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4f866a",
  null
  
)

export default component.exports